import React from "react";
import { useNotify, fetchStart, fetchEnd, useRedirect } from "react-admin";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import Parse from "parse";
import { useDispatch } from "react-redux";
import { Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

import Button from "@material-ui/core/Button";
import { Form, Field } from "react-final-form";
// import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const Dialogstyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(Dialogstyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const AddCertification = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const notify = useNotify();
  let CertificateArray = [];

  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const redirectTo = useRedirect();
  //   let [CertificateArray] = React.useState([]);

  const handleClose = () => {
    setOpen(false);
    history.goBack();
  };
  const handleFileInputChange = (event) => {
    console.log("event", event.target.files);
    for (const [key, value] of Object.entries(event.target.files)) {
      if (typeof value === "object" && key) {
        console.log("value", value);
        CertificateArray.push({
          Certificates: value,
          CertificateName: value.name,
        });
      }
    }
  };

  const handleSubmit = async (response) => {
    console.log("CertificateArray", CertificateArray);
    try {
      dispatch(fetchStart());
      setLoading(true);
      CertificateArray = await Promise.all(
        CertificateArray.map(async (image) => {
          console.log("type", typeof image.Certificates);
          console.log("image.value.size", image);
          if (image.Certificates.size <= 1000000) {
            return {
              Certificatebase64: await toBase64(image.Certificates),
              Certificatename: image.CertificateName,
            };
          } else {
            throw new Error(
              "File size exceeded, file size must be less that or equal to 1 mb"
            );
          }
        })
      );

      console.log("CertificateArray", typeof CertificateArray);
      console.log("CertificateArray", CertificateArray);
      let myData = Object.keys(CertificateArray).map((key) => {
        return CertificateArray[key];
      });
      console.log("myData", myData);

      const Docs = await Promise.all(
        myData.map(
          async (code) => (
            typeof code === "object"
              ? await Parse.Cloud.run("UploadCertificates", {
                  base64: code.Certificatebase64,
                  name: code.Certificatename,
                })
              : ""
          )
        )
      );
      if (Docs) {
        notify("Certificates Uploaded Successfully");
        dispatch(fetchEnd());
        setLoading(false);
        setOpen(false);
        redirectTo("./myprofile");
      }
    } catch (e) {
      notify(e.message, "warning");
      console.log("tHE ERRIR------->", e.toString());
      setLoading(false);
      setOpen(false);
      redirectTo("./myprofile");
    } finally {
      dispatch(fetchEnd());
      setLoading(false);
      setOpen(false);
      redirectTo("./myprofile");
    }
  };
  return (
    <Grid container>
      <Dialog
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          style={{
            textAlign: "center",
          }}
          onClose={handleClose}
        >
          Add Your Offer
        </DialogTitle>
        <Form
          onSubmit={handleSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent
                dividers
                style={{
                  margin: "2vh",
                  padding: "5vh",
                }}
              >
                <Field name="offerImage">
                  {(props) => (
                    <div>
                      <input
                        accept="application/pdf,image/jpg,image/png,image/jpeg"
                        style={{
                          display: "justify",
                        }}
                        id="contained-button-file"
                        onChange={handleFileInputChange}
                        type="file"
                      />
                    </div>
                  )}
                </Field>
              </DialogContent>
              <DialogActions>
                <Button autoFocus onClick={handleClose} color="secondary">
                  Cancel
                </Button>

                <Button autoFocus type="submit" color="primary">
                  {loading ? <CircularProgress /> : "Save"}
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </Dialog>
    </Grid>
  );
};

export default AddCertification;
